<template>
  <header class="cultura-header">
    <div class="header-inner">
      <!-- Navegação desktop (centralizado) -->
      <nav class="header-nav">
        <button
          type="button"
          :class="['nav-btn', { 'nav-btn--active': activeTab === 'dashboard' }]"
          @click="$emit('change-tab', 'dashboard')"
        >
          Visão Geral
        </button>
        <button
          type="button"
          :class="['nav-btn', { 'nav-btn--active': activeTab === 'values' }]"
          @click="$emit('change-tab', 'values')"
        >
          Nossos Pilares
        </button>
        <button
          type="button"
          :class="[
            'nav-btn',
            { 'nav-btn--active': activeTab === 'communication' },
          ]"
          @click="$emit('change-tab', 'communication')"
        >
          Comunicação
        </button>
      </nav>

      <!-- Ícone mobile -->
      <button type="button" class="header-mobile-icon">👥</button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'CulturaHeader',
  props: {
    activeTab: {
      type: String,
      default: 'dashboard',
    },
  },
}
</script>

<style scoped>
.cultura-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
}

.header-inner {
  max-width: 960px;
  margin: 0 auto;
  height: 64px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

/* NAV CENTRALIZADO */
.header-nav {
  display: none;
  gap: 8px;

  /* centralização no desktop */
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nav-btn {
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  background: transparent;
  font-size: 14px;
  color: #64748b;
  cursor: pointer;
  transition: 0.2s;
}

.nav-btn:hover {
  background: #f1f5f9;
}

.nav-btn--active {
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);
}

/* Ícone mobile */
.header-mobile-icon {
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
  color: #64748b;
}

/* Desktop */
@media (min-width: 768px) {
  .header-nav {
    display: flex;
  }
  .header-mobile-icon {
    display: none;
  }
}
</style>
